export default "__VITE_PUBLIC_ASSET__8f377cb8__"